import UnlockIcon from '@mui/icons-material/AutoAwesome'
import CostsIcon from '@mui/icons-material/EuroSymbol'
import HistoryIcon from '@mui/icons-material/History'
import ScoreIcon from '@mui/icons-material/Leaderboard'
import DriverIcon from '@mui/icons-material/PersonSearch'
import ReportsIcon from '@mui/icons-material/ScheduleSend'
import LanguageIcon from '@mui/icons-material/Translate'
import { Button } from '@mui/material'
import { useTranslate } from 'ra-core'
import { useState } from 'react'

import SalesRequestDialog from '../../components/SalesRequestDialog'

const BENEFITS = [
  { key: 'fullHistory', icon: HistoryIcon },
  { key: 'driverDetails', icon: DriverIcon },
  { key: 'costs', icon: CostsIcon },
  { key: 'userScores', icon: ScoreIcon },
  { key: 'exports', icon: ReportsIcon },
  { key: 'translations', icon: LanguageIcon },
]

const HIGHLIGHT_KEYS = ['tailored']

const CustomKpisRequest = ({ variant = 'contained', size = 'medium', fullWidthOnMobile = false }) => {
  const translate = useTranslate()
  const [isOpen, setIsOpen] = useState(false)
  const t = (key) => translate(`mymove.statistics.customKpis.${key}`)

  return (
    <>
      <Button
        variant={variant}
        size={size}
        startIcon={<UnlockIcon />}
        onClick={() => setIsOpen(true)}
        sx={{ whiteSpace: 'nowrap', flexShrink: 0, width: fullWidthOnMobile ? { xs: '100%', md: 'auto' } : 'auto' }}
      >
        {t('open')}
      </Button>
      <SalesRequestDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        subject="Custom KPIs (statistics page)"
        title={t('title')}
        subtitle={t('subtitle')}
        benefits={BENEFITS.map(({ key, icon }) => ({
          icon,
          title: t(`benefits.${key}.title`),
          description: t(`benefits.${key}.description`),
        }))}
        highlights={HIGHLIGHT_KEYS.map((key) => t(`highlights.${key}`))}
        messagePlaceholder={t('messagePlaceholder')}
        submitLabel={t('submit')}
      />
    </>
  )
}

export default CustomKpisRequest
